import { useEffect } from 'react';
import {RiUser6Line} from 'react-icons/ri';
import {useLocation,useNavigate } from 'react-router-dom';
import {BiFoodMenu} from 'react-icons/bi';
import { LuDoorOpen } from "react-icons/lu";
import { BiPhoneCall } from "react-icons/bi";
import { useSelector } from 'react-redux';
import { MdCardMembership } from "react-icons/md";


function DigitalCardMenu() {

  const {pathname} = useLocation();
  const path = pathname.split('/')[pathname.split('/').length - 1]

  const user = useSelector(state=>state.Auth)
  const roles = useSelector(state=>state.Auth.roles)

 

  const navigate = useNavigate();

  useEffect(()=>{
       if(path === 'digital_card'){
        navigate('/digital_card/list')
       }
  },[])

  const menu = [
    {name:'My Cards',icon:MdCardMembership,path:`/digital_card/list`,id:1,color:'',roles:['admin']},
  ] 



  
  
  return (
    <div className='mr-0 md:min-h-screen md:max-h-sceen md:border-r md:min-w-44  md:w-44 md:max-w-44  px-2' >

        <div className={`w-full pt-4 `}>
            <h6 className=' ml-2 mb-2 font-[700] text-[12px]'>Basic Option </h6>
            <div className='flex-wrap flex  md:block w-auto'>
            {menu.map((m)=>(
            
              m.roles.length > 0 && m?.roles?.filter((e) => roles?.includes(e))?.length > 0 &&
              <>                 
                <div key={m.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                  {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3'></span>}
                  <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16} />
                 <span className='font-[500] ml-2 text-[12px]'>{m.name}</span>
                </div>   
              </>   
            ))}
            </div>
        </div>
    </div>
  )
}

export default DigitalCardMenu